module.exports = __webpack_public_path__ + "img/kefu_erweima.f52f360d.png";